export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  TRIALING: 'trialing',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  INCOMPLETE: 'incomplete',
  NONE: 'none',
};

export const SUBSCRIPTION_TIER = {
  NONE: 'none',
  BASIC: 'basic',
  PREMIUM: 'premium',
  PRO: 'pro',
};

export const ENTITLEMENT_KEYS = {
  BEST_BETS_FULL: 'bestBets.full',
  PROMO_FINDER_VIEW: 'promoFinder.view',
  PROMO_FINDER_FULL: 'promoFinder.full',
  ARBITRAGE_VIEW: 'arbitrage.view',
  ARBITRAGE_FULL: 'arbitrage.full',
  PARLAY_PICKER_VIEW: 'parlayPicker.view',
  PARLAY_PICKER_MULTI_BOOK: 'parlayPicker.multiBook',
  VIDEO_BREAKDOWNS_VIEW: 'videoBreakdowns.view',
  DISCORD_ACCESS: 'community.discord',
  ODDS_MOVEMENT_VIEW: 'oddsMovement.view',
  CALCULATORS_VIEW: 'calculators.view',
};

export const TIER_ENTITLEMENTS = {
  [SUBSCRIPTION_TIER.NONE]: [],
  [SUBSCRIPTION_TIER.BASIC]: [
    ENTITLEMENT_KEYS.CALCULATORS_VIEW,
    ENTITLEMENT_KEYS.ODDS_MOVEMENT_VIEW,
  ],
  [SUBSCRIPTION_TIER.PREMIUM]: [
    ENTITLEMENT_KEYS.CALCULATORS_VIEW,
    ENTITLEMENT_KEYS.ODDS_MOVEMENT_VIEW,
    ENTITLEMENT_KEYS.BEST_BETS_FULL,
    ENTITLEMENT_KEYS.PARLAY_PICKER_VIEW,
    ENTITLEMENT_KEYS.PARLAY_PICKER_MULTI_BOOK,
  ],
  [SUBSCRIPTION_TIER.PRO]: [
    ENTITLEMENT_KEYS.CALCULATORS_VIEW,
    ENTITLEMENT_KEYS.ODDS_MOVEMENT_VIEW,
    ENTITLEMENT_KEYS.BEST_BETS_FULL,
    ENTITLEMENT_KEYS.PARLAY_PICKER_VIEW,
    ENTITLEMENT_KEYS.PARLAY_PICKER_MULTI_BOOK,
    ENTITLEMENT_KEYS.PROMO_FINDER_VIEW,
    ENTITLEMENT_KEYS.PROMO_FINDER_FULL,
    ENTITLEMENT_KEYS.ARBITRAGE_VIEW,
    ENTITLEMENT_KEYS.ARBITRAGE_FULL,
    ENTITLEMENT_KEYS.VIDEO_BREAKDOWNS_VIEW,
    ENTITLEMENT_KEYS.DISCORD_ACCESS,
  ],
};

export const FEATURE_ACCESS_POLICIES = {
  [ENTITLEMENT_KEYS.BEST_BETS_FULL]: {
    upgradeTier: SUBSCRIPTION_TIER.PREMIUM,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.PROMO_FINDER_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'preview',
  },
  [ENTITLEMENT_KEYS.PROMO_FINDER_FULL]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.ARBITRAGE_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'preview',
  },
  [ENTITLEMENT_KEYS.ARBITRAGE_FULL]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.PARLAY_PICKER_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.PREMIUM,
    gateMode: 'preview',
  },
  [ENTITLEMENT_KEYS.PARLAY_PICKER_MULTI_BOOK]: {
    upgradeTier: SUBSCRIPTION_TIER.PREMIUM,
    gateMode: 'disabled',
  },
  [ENTITLEMENT_KEYS.VIDEO_BREAKDOWNS_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.DISCORD_ACCESS]: {
    upgradeTier: SUBSCRIPTION_TIER.PRO,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.ODDS_MOVEMENT_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.BASIC,
    gateMode: 'locked',
  },
  [ENTITLEMENT_KEYS.CALCULATORS_VIEW]: {
    upgradeTier: SUBSCRIPTION_TIER.BASIC,
    gateMode: 'locked',
  },
};